import styled from '@emotion/styled'
import { Paper } from '@material-ui/core'

export const Wrapper = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(5, 12)};
  margin: 0 auto;
`
